import React from "react";
import {Flex, Text} from "@chakra-ui/react";
import {
  GrCaretNext,
  GrChapterNext,
  GrCaretPrevious,
  GrChapterPrevious,
} from "react-icons/gr";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  hoveredButton: string | null;
  setHoveredButton: (hovered: string | null) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = (
  {
    currentPage,
    totalPages,
    setCurrentPage,
    hoveredButton,
    setHoveredButton,
  }: PaginationControlsProps) => {

  if (totalPages <= 1) return null;

  return (
    <Flex justify="center" mt={4} gap={2} align="center" className="mr-18">
      <button
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1}
        onMouseEnter={() => setHoveredButton("first")}
        onMouseLeave={() => setHoveredButton(null)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "32px",
          minHeight: "32px",
          gap: "4px",
          borderRadius: "50%",
          opacity: currentPage === 1 ? 0.4 : 1,
          backgroundColor:
            hoveredButton === "first" && currentPage !== 1
              ? "var(--chakra-colors-brandPurple-500)"
              : "transparent",
        }}
      >
        <GrChapterPrevious/>
      </button>
      <button
        onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        onMouseEnter={() => setHoveredButton("prev")}
        onMouseLeave={() => setHoveredButton(null)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "32px",
          minHeight: "32px",
          gap: "4px",
          borderRadius: "50%",
          opacity: currentPage === 1 ? 0.4 : 1,
          backgroundColor:
            hoveredButton === "prev" && currentPage !== 1
              ? "var(--chakra-colors-brandPurple-500)"
              : "transparent",
        }}
      >
        <GrCaretPrevious/>
      </button>
      <Text>
        Page {currentPage} of {totalPages}
      </Text>
      <button
        onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        onMouseEnter={() => setHoveredButton("next")}
        onMouseLeave={() => setHoveredButton(null)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "32px",
          minHeight: "32px",
          gap: "4px",
          borderRadius: "50%",
          opacity: currentPage === totalPages ? 0.4 : 1,
          backgroundColor:
            hoveredButton === "next" && currentPage !== totalPages
              ? "var(--chakra-colors-brandPurple-500)"
              : "transparent",
        }}
      >
        <GrCaretNext/>
      </button>
      <button
        onClick={() => setCurrentPage(totalPages)}
        disabled={currentPage === totalPages}
        onMouseEnter={() => setHoveredButton("last")}
        onMouseLeave={() => setHoveredButton(null)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "32px",
          minHeight: "32px",
          gap: "4px",
          borderRadius: "50%",
          opacity: currentPage === totalPages ? 0.4 : 1,
          backgroundColor:
            hoveredButton === "last" && currentPage !== totalPages
              ? "var(--chakra-colors-brandPurple-500)"
              : "transparent",
        }}
      >
        <GrChapterNext/>
      </button>
    </Flex>
  );
};

export default PaginationControls;